


  import {defineComponent} from 'vue';
  import router from "@/router";
  import {mapGetters, mapMutations} from "vuex";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";

  export default defineComponent({
    name: 'payment-completion-component',
    components: {
      HeaderComponent,
    },
    props: ['orderType', 'resultId'],
    created() {
      this.initReceiverStore();
    },
    methods: {
      moveToMain(): void {
        router.push(new NamedRouting('HomeView'));
      },
      moveToMyOrder(): void {
        router.push(new NamedRouting('OrderDetailView', {orderId: this.resultId}));
      },
      moveToMyTicket(): void {
        const randomTicketId = this.resultId.split(',')[0];
        router.push(new NamedRouting('TicketDetailView', {ticketId: randomTicketId}));
      },
      ...mapMutations('ReceiverStore', [
        'initReceiverStore'
      ])
    },
    computed: {
      isPresentOrder(): boolean {
        return this.orderType === 'GIFT';
      },
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    }
  });
